import { useCallback, useEffect, useState } from "react";

import { getFlowStats } from "@/api/stats";
import { FlowStats } from "@/types/stats";

export function useFlowStats(flowId: string | null, days: number = 30, stepId?: string | null) {
  const [stats, setStats] = useState<FlowStats | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async () => {
    if (!flowId) {
      setStats(null);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const data = await getFlowStats(flowId, days, stepId);
      setStats(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load stats");
    } finally {
      setIsLoading(false);
    }
  }, [flowId, days, stepId]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { stats, isLoading, error, refresh: fetchStats };
}
